import { render, staticRenderFns } from "./ModalAddEditCatering.vue?vue&type=template&id=326343a2&scoped=true&"
import script from "./ModalAddEditCatering.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditCatering.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEditCatering.vue?vue&type=style&index=0&id=326343a2&scoped=true&lang=css&"
import style1 from "./ModalAddEditCatering.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326343a2",
  null
  
)

export default component.exports